import React from 'react';
import { Input as AntInput } from 'antd-v5';
import clearImg from '@/common/images/clear.png';
import './style.less';
function Input(props) {
    const {
        allowClear = true,
        ...nativeProps
    } = props;

    return (
        <AntInput
            allowClear={allowClear ? { clearIcon: <img src={clearImg} alt="clear" style={{ width: 16, height: 16 }} /> } : false}
            {...nativeProps}
            className="ui-input"
        />
    );
}

Input.TextArea = AntInput.TextArea;

export default Input;